import { ARApiError, ARLogger } from '@relayter/core';
import { Toaster } from '../classes/toaster.class';
import * as Sentry from '@sentry/angular';

export default class ErrorService {
    private static readonly UNKNOWN_ERROR_MESSAGE = 'We encountered an error. ' + 'Please try again or contact Relayter support if the issue persists.';

    public static handleError(error: any) {
        if (error instanceof ARApiError) {
            Toaster.handleApiError(error);
        } else {
            Toaster.error(ErrorService.UNKNOWN_ERROR_MESSAGE);
            ARLogger.error(error);
            Sentry.captureException(error);
        }
    }
}
